import noxios from './noxios'
import { toDomainHttpClient } from './toDomainHttpClient'

// 메시징 서버 요청은 트래킹하지 않는다.
export const domainMessagingHttpClient = toDomainHttpClient(noxios, { forwardMeta: false })
